/**
 * Frontend configuration.
 *
 * All values are read from Vite environment variables (prefixed VITE_).
 * Set them in `.env` or `.env.local` at the `frontend/` root:
 *
 *   VITE_API_BASE_URL=http://localhost:8787
 *   VITE_SUPABASE_URL=https://xxx.supabase.co
 *   VITE_SUPABASE_ANON_KEY=eyJ...
 */

/** Base URL for the Cloudflare Worker API (no trailing slash). */
export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL ?? "";

/** Supabase project URL. */
export const SUPABASE_URL: string =
  import.meta.env.VITE_SUPABASE_URL ?? "";

/** Supabase anonymous (public) key — safe to expose in the browser. */
export const SUPABASE_ANON_KEY: string =
  import.meta.env.VITE_SUPABASE_ANON_KEY ?? "";
